import { DropDownOption } from './GlobalInterfaces';

export enum ObjectType {
  Attribute = 1,
  AttributeGroup,
  AttributeOption,
  AttributeSet,
  Brand,
  Category,
  Collection,
  Configuration,
  ConfigurationGroup,
  Currency,
  Manufacturer,
  Product,
  Tag,
  ProductAttribute,
  ProductCategory,
  ProductTag,
  Translation,
}
export const ObjectTypeValidValues: DropDownOption[] = [
  {
    Code: 5,
    Label: 'Brand',
  },
  {
    Code: 6,
    Label: 'Category',
  },
  {
    Code: 7,
    Label: 'Collection',
  },
  // {
  //   Code: 10,
  //   Label: 'Currency',
  // },
  {
    Code: 11,
    Label: 'Manufacturer',
  },
  {
    Code: 12,
    Label: 'Product',
  },
  {
    Code: 13,
    Label: 'Tag',
  },
];
export enum FilterOperator {
  contains = 0,
  doesntContain,
  startsWith,
  isEqual,
  isNotEqual,
  isEmpty,
  isNotEmpty,
  between,
  notBetween,
  greaterThan,
  lessThan,
  greaterOrEqual,
  lessOrEqual,
  inList,
}

export enum SelectionType {
  SelectAll,
  SelectAllInPage,
  Deselect,
}
